__turbopack_context__.v({
  "bottomClearFix": "style-module-scss-module__EBGTra__bottomClearFix",
  "card": "style-module-scss-module__EBGTra__card",
  "cards": "style-module-scss-module__EBGTra__cards",
  "chub": "style-module-scss-module__EBGTra__chub",
  "contentWrapper": "style-module-scss-module__EBGTra__contentWrapper",
  "curvedContainer": "style-module-scss-module__EBGTra__curvedContainer",
  "curvedMask": "style-module-scss-module__EBGTra__curvedMask",
  "curvedText": "style-module-scss-module__EBGTra__curvedText",
  "curvedWrapper": "style-module-scss-module__EBGTra__curvedWrapper",
  "graffitiBg": "style-module-scss-module__EBGTra__graffitiBg",
  "title": "style-module-scss-module__EBGTra__title",
  "wrapper": "style-module-scss-module__EBGTra__wrapper",
});
